<ng-container *ngIf="live">
  <form class="residential-form-main residential-accordion" [formGroup]="residentialForm" (ngSubmit)="submitForm()" (change)="createResidentialLead($event.target.id)" ngxScrollToFirstInvalid>
    <div class="about-your-self section-gap" fxLayout="column" fxLayoutGap="10px" style="margin-bottom: 0;">
      <p class="section-title color_primary">{{ 'residential.tell_about_self' | translate }}</p>
      <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
          <mat-label>{{ 'user.first_name' | translate }}</mat-label>
          <input matInput type="text" formControlName="first_name" id="init_first_name" required
                 [value]="residentialForm.value.first_name">
          <app-form-descriptor matSuffix [message]="('residential.first_name_hint' | translate)"></app-form-descriptor>
          <mat-error *ngIf="f['first_name'].errors">{{ f['first_name'] | errorMsg }}</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
          <mat-label>{{ 'user.middle_name' | translate }}</mat-label>
          <input matInput type="text" formControlName="middle_name" id="init_middle_name"
                 [value]="residentialForm.value.middle_name"
                 [ngClass]="{ 'is-invalid-i': submitted && f.last_name.errors }">
          <app-form-descriptor matSuffix [message]="('residential.middle_name_hint' | translate)"></app-form-descriptor>
          <mat-error *ngIf="f['middle_name'].errors">{{ f['middle_name'] | errorMsg }}</mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
          <mat-label>{{ 'user.last_name' | translate }}</mat-label>
          <input matInput type="text" formControlName="last_name" id="init_last_name" required
                 [value]="residentialForm.value.last_name"
                 [ngClass]="{ 'is-invalid-i': submitted && f.last_name.errors }">
          <app-form-descriptor matSuffix [message]="('residential.last_name_hint' | translate)"></app-form-descriptor>
          <mat-error *ngIf="f['last_name'].errors">{{ f['last_name'] | errorMsg }}</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="50%" appearance="outline">
          <mat-label>{{ 'residential.email_address' | translate }}</mat-label>
          <input matInput type="text"  formControlName="email" id="init_email" required
                 [value]="residentialForm.value.email">
          <app-form-descriptor matSuffix
                               [message]="('residential.email_address_hint' | translate)"></app-form-descriptor>
          <mat-error *ngIf="f['email'].errors" >
            {{ f['email'] | errorMsg }}
          </mat-error>
        </mat-form-field>
      </div>

      <ui-insurables
        [nonpreferredAddressSelection]="nonpreferredAddressSelection"
        [pmaSingleHouses]="pmaSingleHouses"
        [form]="residentialForm"
        [nonApplicableControl]="nonApplicableControl"
        [communityControl]="residentialForm.get('community')"
        [buildingControl]="residentialForm.get('building')"
        [buildingAddressControl]="residentialForm.get('building_address')"
        [buildingAddressCheckbox]="residentialForm.get('building_address_checkbox')"
        (setAccountId)="setAccountId($event)"
        (setAddressAttributes)="setAddressAttributes($event)"
        (stopLoading)="stopInitialLoading()"
        (startLoading)="initialLoading = $event"
        (setPreferredho4)="setPreferredho4($event)"
      ></ui-insurables>

      <div fxLayout="column" class="mat-form-fields_negative-margin">

        <div *ngIf="showCountyField">
          <div>
            <mat-form-field fxFlex="100%" appearance="outline">
              <mat-label>{{ 'residential.county' | translate }}</mat-label>
              <mat-select [formControl]="residentialForm.get('county')" required (ngModelChange)="selectCounty($event)">
                <mat-option *ngFor="let county of counties" [value]="county">{{ county }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <pm-account
          *ngIf="nonpreferredAccountSelection"
          [accountControl]="residentialForm.get('pm_account')"
        ></pm-account>
      </div>

      <div>
        <mat-error *ngIf="coverageOptionsError"
                   fxLayout="row"
                   fxLayoutGap="2px"
                   fxLayoutAlign="start center"
                   class="invalid-input-dedactible">
          <mat-icon class="error-icon">info</mat-icon>
          <span>{{ coverageOptionsError }}</span>
        </mat-error>
      </div>

      <button *ngIf="!initialLeadDataEntered"
              mat-button
              class="mat-btn warning"
              [disabled]="initialLoading || !isValidInitForm || coverageOptionsError"
              [class.spinner]="initialLoading || loadingCoverageOptions"
              (click)="handleInitForm($event)">
        <ng-container *ngIf="!(initialLoading || loadingCoverageOptions)">
          {{ 'form.continue' | translate }}
        </ng-container>
      </button>

      <div>
      </div>
    </div>
    <ng-container *ngIf="residential && initialLeadDataEntered">
      <mat-accordion id="confirm" #confirm>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div>
                <div class="residential-accordion__title">{{ 'residential.tell_us_about_insurance' | translate }}</div>
                <div class="residential-accordion__description">{{'residential.tell_us_about_insurance_description' | translate}}</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row" fxFlexFill fxLayoutGap="10px" fxLayout.lt-sm="column">
            <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline" class="date-with-suffix">
              <mat-label>{{ 'user.effective_date' | translate }}</mat-label>
              <input matInput formControlName="effective_date" type="text" id="effective_date" required
                     [matDatepicker]="picker_effective_date"
                     [min]="minDate"
                     [max]="maxDate"
                     (dateInput)="updateDate('input', $event)" (dateChange)="updateDate('change', $event)"
                     [ngClass]="{ 'is-invalid-i': submitted && f.effective_date.errors }">
              <mat-datepicker #picker_effective_date></mat-datepicker>
              <div matSuffix class="suffix-container">
                <mat-datepicker-toggle [for]="picker_effective_date"></mat-datepicker-toggle>
                <app-form-descriptor
                  [message]="'residential.effective_date_hint' | translate">
                </app-form-descriptor>
              </div>
            </mat-form-field>
            <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline" class="date-with-suffix">
              <mat-label>{{ 'user.expiration_date' | translate }}</mat-label>
              <input matInput formControlName="expiration_date" type="text" id="expiration_date" required
                     [matDatepicker]="picker_expiration_date">
              <mat-datepicker #picker_expiration_date></mat-datepicker>
              <div matSuffix class="suffix-container">
                <mat-datepicker-toggle [for]="picker_expiration_date"></mat-datepicker-toggle>
                <app-form-descriptor
                  [message]="('residential.expiration_date_hint' | translate)"></app-form-descriptor>
              </div>
            </mat-form-field>
          </div>

          <div *ngIf="isEffectiveDateEqualToday">
            <mat-checkbox [formControl]="controlConfirmToday"
                          style="margin-bottom: 25px;"
                          color="primary"
                          labelPosition="after"
            >
              {{ 'form.i_certify_there_have_been_no_losses' | translate }}
            </mat-checkbox>
          </div>

          <div fxLayout="column">
            <mat-form-field appearance="outline">
              <mat-label>{{'residential.payment_plan_options' | translate}}</mat-label>
              <mat-select formControlName="billing_strategy_id" id="billing_strategy_id" required (ngModelChange)="createResidentialLead('billing_strategy_id')">
                <mat-option *ngFor="let number of billingStrategyId" [value]="number.value">{{number.label | translate | titlecase }}</mat-option>
              </mat-select>
              <app-form-descriptor matSuffix
                                   [message]="('residential.billing_strategy_hint' | translate)"></app-form-descriptor>
              <mat-error *ngIf="f['billing_strategy_id'].errors">{{ f['billing_strategy_id'] | errorMsg : ('residential.billing_period' | translate) }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="100%" appearance="outline" *ngIf="f['billing_strategy_id'].value !== 'Annually' && !isQBE">
              <mat-label>{{ 'residential.select_installment_day' | translate }}</mat-label>
              <mat-select formControlName="installment_day" id="installment_day" required
                [compareWith]="compareInstallmentItems"
              >
                <mat-option *ngFor="let day of installmentDays" [value]="day">{{day}}</mat-option>
              </mat-select>
              <mat-error>{{ f['installment_day'] | errorMsg }}</mat-error>
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div *ngIf="loadingCoverageOptions" style="width: 100%; margin: 20px 0;">
        <div fxFlex="100%"
             fxLayout="row"
             fxLayoutGap="20px"
             fxLayoutAlign="center center">
          <p>Loading your Coverage Options</p>
          <div>
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        </div>
      </div>

      <div *ngIf="!loadingCoverageOptions" @fade>
        <mat-accordion *ngIf="isCoverageOptions">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div>
                  <div class="residential-accordion__title">{{ 'residential.coverage_options' | translate }}</div>
                  <div class="residential-accordion__description">{{'residential.coverage_options_description' | translate}}</div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-new-carrier-rates
              fxLayout="column"
              [additionalOptions]="additionalOptions"
              [newCarrierForm]="f['new_carrier']"
              [submitted]="submitted"
              [coverageOptions]="coverageOptions"
            ></app-new-carrier-rates>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <div style="margin: 5px 0 10px;">
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div>
                  <div class="residential-accordion__title">{{ 'residential.insured_detail' | translate }}</div>
                  <div class="residential-accordion__description">{{'residential.insured_detail_description' | translate}}</div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="section-gap" fxLayout="column" fxLayoutGap="10px">
              <div class="section-title section-title_insured-details color_primary" style="height: 100%;" fxLayout="row" fxLayoutAlign="space-between">
                <!--<div fxFlex="">{{ 'residential.insured_detail' | translate }}</div>-->
                <div fxFlex=""></div>
   <!--             <div fxFlex="" class="insured-step">1 out of {{residentialForm.controls.number_of_insured.value}}</div>-->
              </div>
              <div class="inline-input-items"fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" style="height: 100%">
                <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
                  <mat-label>{{ 'user.first_name' | translate }}</mat-label>
                  <input matInput type="text" formControlName="first_name" id="first_name" required
                         [value]="residentialForm.value.first_name">
                  <app-form-descriptor matSuffix [message]="('residential.first_name_hint' | translate)"></app-form-descriptor>
                  <mat-error *ngIf="f['first_name'].errors">{{ f['first_name'] | errorMsg }}</mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
                  <mat-label>{{ 'user.middle_name' | translate }}</mat-label>
                  <input matInput type="text" formControlName="middle_name" id="init_middle_name"
                         [value]="residentialForm.value.middle_name"
                         [ngClass]="{ 'is-invalid-i': submitted && f.last_name.errors }">
                  <app-form-descriptor matSuffix [message]="('residential.middle_name_hint' | translate)"></app-form-descriptor>
                  <mat-error *ngIf="f['middle_name'].errors">{{ f['middle_name'] | errorMsg }}</mat-error>
                </mat-form-field>
              </div>

              <div class="inline-input-items"fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" style="height: 100%">
                <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
                  <mat-label>{{ 'user.last_name' | translate }}</mat-label>
                  <input matInput type="text" formControlName="last_name" id="last_name" required
                         [value]="residentialForm.value.last_name">
                  <app-form-descriptor matSuffix [message]="('residential.last_name_hint' | translate)"></app-form-descriptor>
                  <mat-error *ngIf="f['last_name'].errors">
                    {{ f['last_name'] | errorMsg }}
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="50%" appearance="outline">
                  <mat-label>{{ 'residential.email_address' | translate }}</mat-label>
                  <input matInput type="text" formControlName="email" id="email" required
                         [value]="residentialForm.value.email">
                  <app-form-descriptor matSuffix
                                       [message]="('residential.email_address_hint' | translate)"></app-form-descriptor>
                  <mat-error *ngIf="f['email'].errors">{{ f['email'] | errorMsg }}</mat-error>
                </mat-form-field>
              </div>

              <mat-form-field fxFlex="100%" appearance="outline" class="date-with-suffix">
                <mat-label>{{ 'user.birth_date' | translate }}</mat-label>
                <input matInput formControlName="birth_date_main" type="text" id="birth_date_main" [matDatepicker]="picker_birthday"
                       (ngModelChange)="createResidentialLead('birth_date_main')" required
                       [max]="maxBirthdayDate">
                <mat-datepicker #picker_birthday startView="multi-year"></mat-datepicker>
                <div matSuffix class="suffix-container">
                  <mat-datepicker-toggle [for]="picker_birthday"></mat-datepicker-toggle>
                  <app-form-descriptor [message]="('residential.date_of_birth_hint' | translate)"></app-form-descriptor>
                </div>
              </mat-form-field>

              <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>{{ 'residential.contact_phone' | translate }}</mat-label>
                <input matInput type="text" formControlName="contact_phone" id="contact_phone" required
                       mask="(000) 000-0000">
                <app-form-descriptor matSuffix
                                     [message]="('residential.phone_number_hint' | translate)"></app-form-descriptor>
                <mat-error *ngIf="f['contact_phone'].errors">
                  {{ f['contact_phone'] | errorMsg: ('residential.contact_phone' | translate) : 'phone' }}
                </mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>{{ 'residential.mailing_address_line_one' | translate }}</mat-label>
                <input matInput type="text" formControlName="street_name" id="street_name" required>
                <mat-error *ngIf="submitted && f['street_name'].errors">
                  {{ f['street_name'] | errorMsg }}
                </mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>{{ 'residential.mailing_address_line_two' | translate }}</mat-label>
                <input matInput type="text" formControlName="street_two" id="street_two">
                <mat-error *ngIf="f['street_two'].errors">
                  {{ f['street_two'] | errorMsg: ('user.unit' | translate) }}
                </mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>{{ 'residential.mailing_city' | translate }}</mat-label>
                <input matInput type="text" formControlName="city" id="city" required>
                <app-form-descriptor matSuffix
                                     [message]="('residential.city_hint' | translate)"></app-form-descriptor>
                <mat-error *ngIf="f['city'].errors" class="invalid-input-dedactible">
                  {{ f['city'] | errorMsg }}
                </mat-error>
              </mat-form-field>

              <div class="inline-input-items" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" style="height: 100%">
                <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
                  <mat-label>{{ 'residential.mailing_state' | translate }}</mat-label>
                  <mat-select formControlName="state" id="state" required (ngModelChange)="createResidentialLead('state')">
                    <mat-option *ngFor="let state of stateList; let i=index;" [value]="state">{{state}}</mat-option>
                  </mat-select>
                  <app-form-descriptor matSuffix
                                       [message]="('residential.state_hint' | translate)"></app-form-descriptor>
                  <mat-error *ngIf="f['state'].errors">
                    {{ f['state'] | errorMsg }}
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
                  <mat-label>{{ 'residential.mailing_zip_code' | translate }}</mat-label>
                  <input matInput type="text" formControlName="postal_code" id="postal_code" mask="00000" required
                         [ngClass]="{ 'is-invalid-i': submitted && f.postal_code.errors }">
                  <app-form-descriptor matSuffix
                                       [message]="('residential.postal_code_hint' | translate)"></app-form-descriptor>
                  <mat-error *ngIf="f['postal_code'].errors">
                    {{ f['postal_code'] | errorMsg: undefined: 'zip'  }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <button mat-button *ngIf="!f.insured_user_arr['controls'] || f.insured_user_arr['controls'].length === 0"
                    (click)="addInsured($event)">
              <mat-icon>add</mat-icon>
              {{'residential.add_insured_button' | translate}}
            </button>
            <div class="section-gap" *ngFor="let group of f.insured_user_arr['controls']; let i=index;">
              <app-residential-insured-details
                [form]="group"
                [index]="i"
                [totalAdditionalInsured]="f.insured_user_arr['controls'].length"
                (removeInsured)="removeInsured(i)"
                (spouseChanged)="checkSpouse(group, i)"
                (leadDataChanged)="createResidentialLead($event)">
              </app-residential-insured-details>
              <button mat-button *ngIf="i + 1 === f.insured_user_arr['controls'].length && f.insured_user_arr['controls'].length < maxAdditionalInsured" (click)="addInsured($event)">
                <mat-icon>add</mat-icon>
                {{'residential.add_insured_button' | translate}}
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div *ngIf="isPmDetailsForm" style="margin-top: -25px; margin-bottom: 20px; width: 100%;">
        <app-pm-details-form [form]="f['pm_details']"
                             [isUpdater]="false"
        ></app-pm-details-form>
        <app-community-details-form *ngIf="!isUpdater" [form]="f['community_details']" [isExpandedCommunityDetails]="isExpandedCommunityDetails"></app-community-details-form>
      </div>

      <div *ngIf="isAllTenantsListed">
        <mat-checkbox [formControl]="controlAllTenantsListed"
                      style="margin: 5px 0 22px 0;"
                      color="primary"
                      labelPosition="after"
                      class="mat-checkbox-confirm"
        >
          {{ 'form.clicking_box_roommates' | translate }}
        </mat-checkbox>
      </div>

      <div class="paperless-ch">
        <mat-checkbox
                      color="primary"
                      class="mat-checkbox-confirm"
                      formControlName="paperless_flag"
        >
          {{ 'residential.paperless.checkbox' | translate }} <br />
          <a href="#" (click)="showPaperlessAgreement($event)">
            {{ 'residential.paperless.link' | translate }}
          </a>
        </mat-checkbox>
      </div>

      <div class="estimate section-gap">
        <button mat-button
                class="mat-btn warning full-width"
                [disabled]="loader || this.loadingCoverageOptions"
                [class.spinner]="loader || this.loadingCoverageOptions">
          <ng-container *ngIf="!(loader || this.loadingCoverageOptions)">
            {{ (customRgPage$ | async) === 'freeway' ? ('form.continue' | translate) : ('form.get_covered_now' | translate) }}
          </ng-container>
        </button>
      </div>
    </ng-container>

    <powered-by-gc *brandingAttr="'powered_by_gc_footer'"></powered-by-gc>

  </form>
  <!--<div *ngIf="residential && residential.carrier_id">-->
    <!--<div *ngIf="isQBE; else residential_disclosure_block" class="residential-disclosure-block">-->
      <!--{{ 'residential.disclosure_block_qbe' | translate }}-->
    <!--</div>-->
    <!--<ng-template #residential_disclosure_block>-->
      <!--<div class="residential-disclosure-block">-->
        <!--{{ 'residential.disclosure_block' | translate }}-->
      <!--</div>-->
    <!--</ng-template>-->
  <!--</div>-->
</ng-container>

